import {initializeApp} from "firebase/app";
import {getFirestore, connectFirestoreEmulator} from "firebase/firestore";
import {getAuth, connectAuthEmulator, onAuthStateChanged} from "firebase/auth";
import {getStorage, connectStorageEmulator} from "firebase/storage";


const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};


const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

if (process.env.NODE_ENV === "development") {
  console.log("Connecting to Firebase emulators...");
  try {
    connectAuthEmulator(auth, "http://localhost:9099", {disableWarnings: true});
    connectFirestoreEmulator(db, "localhost", 8080);
    connectStorageEmulator(storage, "localhost", 9199);
    console.log("Successfully connected to emulators");

    // Keep the auth state listener for debugging
    onAuthStateChanged(auth, (user) => {
      console.log("Auth state changed:", {
        isAuthenticated: !!user,
        user: user ? {
          uid: user.uid,
          email: user.email
        } : null
      });
    });
  } catch (error) {
    console.error("Error connecting to emulators:", error);
  }
}

export {app, db, auth, storage};
